import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ColorPickerService } from 'angular4-color-picker';
import { MapService } from '../../../services/map/map.service';
import 'rxjs/Rx';
// Molt important declarar-ho. Altrament, NO funciona.
import * as ol from 'openlayers';
declare var $;//jquerys


const imatgesURL = [
    "./assets/img/draw_images/01_cercle1.png",
    "./assets/img/draw_images/02_cercle2.png",
    "./assets/img/draw_images/03_cercle3.png",
    "./assets/img/draw_images/04_cercle4.png",
    "./assets/img/draw_images/05_cercle5.png",
    "./assets/img/draw_images/06_cercle6.png",
    "./assets/img/draw_images/07_cercle7.png",
    "./assets/img/draw_images/08_quadrat1.png",
    "./assets/img/draw_images/09_quadrat2.png",
    "./assets/img/draw_images/10_quadrat3.png",
    "./assets/img/draw_images/11_quadrat4.png",
    "./assets/img/draw_images/12_quadrat5.png",
    "./assets/img/draw_images/13_quadrat6.png",
    "./assets/img/draw_images/14_quadrat7.png",
    "./assets/img/draw_images/15_triangle1.png",
    "./assets/img/draw_images/16_triangle2.png",
    "./assets/img/draw_images/17_triangle3.png",
    "./assets/img/draw_images/18_triangle4.png",
    "./assets/img/draw_images/19_triangle5.png",
    "./assets/img/draw_images/20_triangle6.png",
    "./assets/img/draw_images/21_triangle7.png",
    "./assets/img/draw_images/22_rombe1.png",
    "./assets/img/draw_images/23_rombe2.png",
    "./assets/img/draw_images/24_rombe3.png",
    "./assets/img/draw_images/25_rombe4.png",
    "./assets/img/draw_images/26_rombe5.png",
    "./assets/img/draw_images/27_rombe6.png",
    "./assets/img/draw_images/28_rombe7.png"];

const default_tools = {
    drawImage: false,
    drawLinestring: false,
    drawPolygon: false,
    drawText: false,
    uploadKML: false
};

@Component({
    selector: 'app-draw-control',
    templateUrl: './draw-control.component.html',
    styleUrls: ['./draw-control.component.css']
})
export class DrawControlComponent implements OnInit {
    /* Events Emitter's */
    @Output() private addInteraction = new EventEmitter<any>();
    @Output() private removeInteraction = new EventEmitter<any>();
    @Output() private addLayerTool = new EventEmitter<any>();


    private textLabel: string;
    private lengthStrokePolygon = 3;
    private lengthStrokeLinestring = 3;
    private lengthText = 15;
    private colorLinestringFill: string = "#c1f3c7";
    private colorLinestringStroke: string = "#15804f";
    private colorPolygonFill: string = "#eef6fd";
    private colorPolygonStroke: string = "#127bdc";
    private colorText: string = "#000000";
    private kmlFileInput;
    private imageURLList = imatgesURL;
    private drawInteraction: ol.interaction.Draw = null;
    private sketch: ol.Feature;

    private activeTool = {
        drawImage: false,
        drawLinestring: false,
        drawPolygon: false,
        drawText: false,
        uploadKML: false
    };

    private onDrawStart;
    private onDrawEnd;

    private sourceFeaturesLayer: ol.source.Vector;
    private drawFeaturesLayer: ol.layer.Vector = null;
    private numFeaturesAdded: number = 0;

    private arrClasses = {
        drawImage: {
            iconDrawHeaderDown: this.activeTool.drawImage,
            iconDrawHeaderUp: !this.activeTool.drawImage
        },
        drawLinestring: {
            iconDrawHeaderDown: this.activeTool.drawLinestring,
            iconDrawHeaderUp: !this.activeTool.drawLinestring
        },
        drawPolygon: {
            iconDrawHeaderDown: this.activeTool.drawPolygon,
            iconDrawHeaderUp: !this.activeTool.drawPolygon
        },
        drawText: {
            iconDrawHeaderDown: this.activeTool.drawText,
            iconDrawHeaderUp: !this.activeTool.drawText
        }
    };
    private kmlFormat: ol.format.KML;
    private urlImageActive: string = "";

    constructor(private cpService: ColorPickerService, private mapService: MapService) {

    }

    ngOnInit() {
        //Creem el nostre format per tal de poder extraure els estils dels features
        this.kmlFormat = new ol.format.KML({
            extractStyles: true,
            writeStyles: true,
            showPointNames: false,
            defaultStyle: [
                new ol.style.Style({
                    image: new ol.style.Circle({
                        radius: 7,
                        fill: new ol.style.Fill({
                            color: '#ffcc33'
                        })
                    })
                })]
        });

        if (this.drawFeaturesLayer == null) {
            this.createLayer();
        }
    }

    private createLayer() {
        this.drawFeaturesLayer = new ol.layer.Vector({
            source: new ol.source.Vector(),
            style: new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(255, 255, 255, 0.2)'
                }),
                stroke: new ol.style.Stroke({
                    color: '#ffcc33',
                    width: 2
                }),
                image: new ol.style.Circle({
                    radius: 7,
                    fill: new ol.style.Fill({
                        color: '#ffcc33'
                    })
                })
            })
        });

        let properties = {
            id: "olDrawTool",
            name: "olDrawTool",
            zIndex: 1000,
            isTool: true
        };

        this.drawFeaturesLayer.setProperties(properties, true);
        this.addLayerTool.emit(this.drawFeaturesLayer);
    }

    private removeInteractionHandler(): void {
        console.debug(">>> DrawControlComponent ---> removeInteractionHandler");
        this.removeInteraction.emit({ closePanel: true, interaction: this.drawInteraction });
    }

    private getDrawStyle(interactionType): ol.style.Style[] {
        let style = [];
        if (interactionType.toLowerCase() === "point" && this.activeTool.drawImage) {
            style = [new ol.style.Style({
                image: new ol.style.Icon(({
                    //scale: 1 + rnd,
                    rotateWithView: true,
                    anchor: [0.5, 0.5],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'fraction',
                    opacity: 1,
                    src: this.urlImageActive
                }))
            })];
        } else if (interactionType.toLowerCase() === "linestring") {
            style = [
                new ol.style.Style({
                    stroke: new ol.style.Stroke({
                        color: this.colorLinestringStroke,
                        width: Number.parseInt(this.lengthStrokeLinestring + "") + 5
                    })
                }), new ol.style.Style({
                    stroke: new ol.style.Stroke({
                        color: this.colorLinestringFill,
                        width: Number.parseInt(this.lengthStrokeLinestring + "")
                    })
                })];
        } else if (interactionType.toLowerCase() === "polygon") {
            style = [new ol.style.Style({
                fill: new ol.style.Fill({
                    color: this.colorPolygonFill
                }),
                stroke: new ol.style.Stroke({
                    color: this.colorPolygonStroke,
                    width: this.lengthStrokePolygon
                }),
                image: new ol.style.Circle({
                    radius: this.lengthStrokePolygon,
                    fill: new ol.style.Fill({
                        color: this.colorPolygonFill
                    })
                })
            })];
        } else if (interactionType.toLowerCase() === "point" && this.activeTool.drawText) {
            style = [
                new ol.style.Style({
                    text: new ol.style.Text({
                        font: 'bold ' + this.lengthText + 'px Arial',
                        text: this.textLabel,
                        rotation: 0,
                        fill: new ol.style.Fill({
                            color: this.colorText
                        })
                    }),
                    image: new ol.style.Circle({	//Punt sense cercle perqué no surti el placemark.
                        radius: 0
                    })
                })
            ];
        }
        return style;
    }


    private createInteraction(interactionType) {

        console.debug("this.createInteraction");
        // layer on dibuixarem els features
        this.drawInteraction = new ol.interaction.Draw({
            source: this.drawFeaturesLayer.getSource(),
            type: interactionType,
            style: this.getDrawStyle(interactionType)
        });

        this.onDrawStart = (event) => {
            console.log("!! >>> this.onDrawStart <<< !!");
            console.debug("this.onDrawStart event >>> ", interactionType);
            console.debug("this.onDrawStart features added (before) >>> ", this.numFeaturesAdded);
            this.sketch = event.feature;
            this.numFeaturesAdded++;
            console.debug("this.onDrawStart features added (after) >>> ", this.numFeaturesAdded);

            let props = {
                id: this.numFeaturesAdded,
                geometryType: interactionType,
                lengthStrokePolygon: this.lengthStrokePolygon,
                lengthStrokeLinestring: this.lengthStrokeLinestring,
                colorLinestringFill: this.colorLinestringFill,
                colorLinestringStroke: this.colorLinestringStroke,
                colorPolygonFill: this.colorPolygonFill,
                colorPolygonStroke: this.colorPolygonStroke,
                urlImageActive: (this.textLabel === undefined) ? (document.baseURI + this.urlImageActive) : document.baseURI,
                colorText: this.colorText,
                textLabel: this.textLabel,
                lengthText: this.lengthText,
            };
            event.feature.setProperties(props, true);
            event.feature.setStyle(this.getDrawStyle(interactionType));
            this.drawFeaturesLayer.getSource().once('addfeature', this.onDrawEnd);
        };

        this.onDrawEnd = (event) => {
            console.log("!! >>> this.onDrawEnd <<< !!");
            if (interactionType === "LineString") {
                event.feature.setStyle([this.getDrawStyle(interactionType)[0]]);
                let feature = new ol.Feature();
                feature.setGeometry(event.feature.getGeometry());
                feature.setStyle([this.getDrawStyle(interactionType)[1]]);
                this.drawFeaturesLayer.getSource().addFeature(feature);
            }

        };

        this.drawInteraction.on('drawstart', this.onDrawStart);
        this.drawInteraction.setProperties({ idInteraction: "olDrawTool" }, true);
        this.addInteraction.emit(this.drawInteraction);
    }
    private resetTools() {
        this.activeTool.drawText = false;
        this.activeTool.drawImage = false;
        this.activeTool.drawLinestring = false;
        this.activeTool.drawPolygon = false;
    }
    private drawImageClicked() {
        let actualState = this.activeTool.drawImage;
        this.resetTools();
        this.activeTool.drawImage = !actualState;

        if (!this.activeTool.drawImage && this.drawInteraction !== null) {
            console.debug("this.drawImageClicked >>> remove interaction");
            this.removeInteraction.emit({ closePanel: false, interaction: this.drawInteraction });
            this.drawInteraction = null;
        }
    }

    private toggleDrawImage(urlImage) {
        this.urlImageActive = urlImage;
        if (this.drawInteraction !== null) {
            this.removeInteraction.emit({ closePanel: false, interaction: this.drawInteraction });
            this.drawInteraction = null;
        }
        if (this.activeTool.drawImage) {
            this.createInteraction("Point");
            this.textLabel = undefined;
        }
    }

    private toggleDrawLinestring($event) {
        let actualState = this.activeTool.drawLinestring;
        this.resetTools();
        this.activeTool.drawLinestring = !actualState;
        if (this.activeTool.drawLinestring) {
            this.removeInteraction.emit({ closePanel: false, interaction: this.drawInteraction });
            this.drawInteraction = null;
            this.createInteraction("LineString");
        }
    }

    private toggleDrawPolygon($event) {
        let actualState = this.activeTool.drawPolygon;
        this.resetTools();
        this.activeTool.drawPolygon = !actualState;
        if (this.activeTool.drawPolygon) {
            this.removeInteraction.emit({ closePanel: false, interaction: this.drawInteraction });
            this.drawInteraction = null;
            this.createInteraction("Polygon");
        }
    }

    private toggleDrawText($event) {
        let actualState = this.activeTool.drawText;
        this.resetTools();
        this.activeTool.drawText = !actualState;
        if (this.activeTool.drawText) {
            this.removeInteraction.emit({ closePanel: false, interaction: this.drawInteraction });
            this.drawInteraction = null;
            this.createInteraction("Point");
        }
    }

    private downloadKML() {
        var docToString = this.kmlFormat.writeFeatures(
            this.drawFeaturesLayer.getSource().getFeatures(),
            {
                dataProjection: ol.proj.get("EPSG:4326"),
                featureProjection: this.mapService.getConfigurationSaved()["mapconfig"].srs
            }
        );

        docToString = docToString.replace(/<Icon>\s*<href>noimage<\/href>\s*<\/Icon>/g, "");

        let blob = new Blob([docToString], { type: 'application/vnd.google-earth.kml+xml' });
        let url = window.URL.createObjectURL(blob);

        $("<a style='display:none' href='" + url + "' download='dibuix.kml'></a>").appendTo("body")[0].click();
    }

    private toggleUploadKML() {
        let actualState = this.activeTool.uploadKML;
        this.resetTools();
        this.activeTool.uploadKML = !actualState;
        if (this.activeTool.uploadKML) {
            $("#kml").click();
        }
    }

    private uploadKML() {
        let file = (<HTMLInputElement>document.getElementById("kml")).files[0];
        let fileReader = new FileReader();

        fileReader.readAsText(file);
        //try to read file, this part does not work at all, need a solution
        fileReader.onloadend = (loadedFile) => {
            try {
                let textKML = fileReader.result
                if (textKML.length > 0 && textKML.indexOf("kml") >= 0) {//és un text i és potencialment un "KML"
                    let features = this.kmlFormat.readFeatures(textKML, {
                        dataProjection: ol.proj.get("EPSG:4326"),
                        featureProjection: this.mapService.getConfigurationSaved()["mapconfig"].srs
                    });
                    this.drawFeaturesLayer.getSource().addFeatures(features);
                }
            } catch (e) {
                console.warn("No hem pogut afegir el dibuix kml correctament", e);
            }
            console.log("fileReader.onloadend", loadedFile);
        }
    }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/tools/draw-control/draw-control.component.ts